import React from 'react';

const CalendarIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M2.15701 3.09375H21.8445C21.8445 3.09375 22.782 3.09375 22.782 4.03125V21.8438C22.782 21.8438 22.782 22.7812 21.8445 22.7812H2.15701C2.15701 22.7812 1.21951 22.7812 1.21951 21.8438V4.03125C1.21951 4.03125 1.21951 3.09375 2.15701 3.09375Z"
        stroke="#4B4B4B"
      />
      <path d="M5.90701 1.21875V5.90625" stroke="#4B4B4B" />
      <path d="M18.0945 1.21875V5.90625" stroke="#4B4B4B" />
      <path d="M1.21951 7.78125H22.782" stroke="#4B4B4B" />
    </g>
  </svg>
);

export default CalendarIcon;
